import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import {
	faGithub,
	faLinkedin,
	faInstagram,
} from "@fortawesome/free-brands-svg-icons";

import INFO from "../../data/user";

import "./styles/socials.css";

const Socials = () => {
	return (
		<div className="homepage-page-socials">
			<a
				href={INFO.socials.linkedin}
				target="_blank"
				rel="noreferrer"
			>
				<FontAwesomeIcon
					icon={faLinkedin}
					className="homepage-social-icon"
				/>
			</a>
			<a
				href={INFO.socials.twitter}
				target="_blank"
				rel="noreferrer"
			>
				<svg
					className="homepage-social-icon"
					width="25"
					height="25"
					viewBox="0 0 24 24"
					fill="currentColor"
				>
					<path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
				</svg>
			</a>
			<a
				href={INFO.socials.github}
				target="_blank"
				rel="noreferrer"
			>
				<FontAwesomeIcon
					icon={faGithub}
					className="homepage-social-icon"
				/>
			</a>
			<a
				href={INFO.socials.instagram}
				target="_blank"
				rel="noreferrer"
			>
				<FontAwesomeIcon
					icon={faInstagram}
					className="homepage-social-icon"
				/>
			</a>
			<a
				href={`mailto:${INFO.main.email}`}
				target="_blank"
				rel="noreferrer"
			>
				<FontAwesomeIcon
					icon={faEnvelope}
					className="homepage-social-icon"
				/>
			</a>
		</div>
	);
};

export default Socials;
